import { useState, useRef } from 'react';

export interface SavedSort {
  id: string;
  desc: boolean;
}

const getSavedSort = (key: string): SavedSort | null => {
  try {
    const stored = localStorage.getItem(key);
    const parsed = stored ? JSON.parse(stored) : null;
    return parsed && parsed.id ? parsed : null;
  } catch {
    return null;
  }
};

const useTableSort = (storageKey: string, defaultSort?: SavedSort) => {
  const [saved] = useState(() => getSavedSort(storageKey));
  const lastSortRef = useRef(saved);

  // A sort the user picked always wins over the table's default.
  const effective = saved ?? defaultSort;

  const initialSortBy = effective
    ? [{ id: effective.id, desc: effective.desc }]
    : [];

  const initialFilterParams = effective
    ? { sortColumn: effective.id, sortDesc: effective.desc }
    : {};

  const persistSort = (sortColumn: string | null, sortDesc: boolean) => {
    const prev = lastSortRef.current;
    if (prev?.id === sortColumn && prev?.desc === sortDesc) return;

    if (sortColumn) {
      const next = { id: sortColumn, desc: sortDesc };
      localStorage.setItem(storageKey, JSON.stringify(next));
      lastSortRef.current = next;
    } else {
      localStorage.removeItem(storageKey);
      lastSortRef.current = null;
    }
  };

  return { initialSortBy, initialFilterParams, persistSort };
};

export default useTableSort;
